import type { LayerKey } from '@festina-life/api'
import { useMemo } from 'react'

import { useLazyLayerMetaModel } from '../../context/useLazyLayerMetaModel'
import { transformResult } from './helpers'
import { useTemplateReferenceModel } from './useTemplateReferenceModel'

const transformRootTypeName = (rootTypeName: string) => {
  switch (rootTypeName.toLowerCase()) {
    case 'cover':
    case 'policy':
    case 'commitment':
      return 'CommitmentTemplate'
    case 'portfolio':
    case 'groupprofile':
      return 'PortfolioTemplate'
    case 'cccalcstepgroup':
    case 'cccalcdef':
    case 'cccalcdefmapping':
      return 'CcCalcDefMappingTemplate'
    default:
      return null
  }
}

export const useTemplateReferenceHierarchy = ({
  rootTypeName,
  layer,
  block,
}: {
  rootTypeName: string | undefined
  layer: LayerKey
  block: string
}) => {
  const name = rootTypeName
    ? transformRootTypeName(rootTypeName.toLowerCase())
    : undefined

  const referenceModel = useTemplateReferenceModel(name)
  const metaModel = useLazyLayerMetaModel(layer.layerId)

  return useMemo(
    () =>
      referenceModel
        ? transformResult({
            data: referenceModel,
            meta: metaModel,
            layer,
            block,
          })
        : null,
    [metaModel, referenceModel, layer, block],
  )
}
